import { createContext } from 'react';

// Provided by MainLayoutFrame, which owns the chat file dropzone so a drag
// anywhere over the chat column OR the widgets drawer hits one shared drop
// target with a single overlay spanning both panes. ChatSurface consumes this
// to wire the composer into that dropzone instead of owning its own.
export const ChatDropzoneContext = createContext(null);
